/**
 * Asynchronously loads the component for OpeningDetailsSettings
 */

import loadable from 'utils/loadable';

export const OpeningDetailsSettings = loadable(() => import('./index'), {
  fallback: null,
});
